export default "__VITE_PUBLIC_ASSET__a667fdac__"